<template>
    <section class="relative overflow-visible">
        <div class="py-8 md:py-12">
            <!-- Title: Match blog style (text-5xl = 48px) -->
            <h1 class="mb-4 text-center text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl md:text-5xl">
                {{ title }}
            </h1>

            <!-- Description: Match blog style (text-xl = 20px) -->
            <p v-if="description" class="mx-auto mb-6 max-w-2xl text-center text-xl text-gray-600 dark:text-txt-body">
                {{ description }}
            </p>

            <!-- Optional action buttons slot (above search) -->
            <div v-if="$slots.actions" class="mb-8 flex flex-wrap justify-center gap-3">
                <slot name="actions" />
            </div>

            <!-- Filter + optional sidebar layout -->
            <div :class="$slots.sidebar ? 'flex flex-col lg:flex-row gap-6 items-center' : ''">
                <!-- Unified Search Filter -->
                <div :class="$slots.sidebar ? 'flex-1 w-full lg:w-auto' : 'mx-auto max-w-3xl w-full'">
                    <UniversalSearchFilter
                        :model-value="modelValue"
                        :collection="collection"
                        :filter-options="filterOptions"
                        :filter-sections="filterSections"
                        :hidden-filters="hiddenFilters"
                        :is-loading="isLoading"
                        :placeholder="placeholder"
                        :prominent-search="prominentSearch"
                        :quick-filters="quickFilters"
                        :search-suggestions="searchSuggestions"
                        @search="$emit('search', $event)"
                        @update:model-value="$emit('update:modelValue', $event)"
                    >
                        <template #results-count>
                            <slot name="results-count" />
                        </template>
                        <template v-if="$slots.filters" #filters="slotProps">
                            <slot name="filters" v-bind="slotProps" />
                        </template>
                    </UniversalSearchFilter>
                </div>

                <!-- Optional sidebar (e.g., map) -->
                <div v-if="$slots.sidebar" class="w-full lg:w-1/2 flex-shrink-0">
                    <slot name="sidebar" />
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import UniversalSearchFilter from '@/components/filters/UniversalSearchFilter.vue'
import type { FilterSection, QuickFilter, SearchSuggestion } from '@/components/filters/UniversalSearchFilter.vue'

defineProps<{
    title: string
    description?: string
    modelValue: Record<string, any>
    collection?: 'jobs' | 'mentors' | 'skills' | 'projects' | 'volunteers'
    placeholder?: string
    filterSections?: FilterSection[]
    quickFilters?: QuickFilter[]
    searchSuggestions?: SearchSuggestion[]
    filterOptions?: Record<string, any[]>
    hiddenFilters?: string[]
    isLoading?: boolean
    prominentSearch?: boolean
}>()

defineEmits<{
    (e: 'update:modelValue', value: Record<string, any>): void
    (e: 'search', query: string): void
}>()
</script>
